export const usePageEnvironment = () => {
  const { environment } = useRuntimeConfig().public
  const url = useRequestURL()
  // Also have to get the path from the requestUrl because since nuxt 4.5.0, useRoute doesn't return the url anymore
  // to which we are transitioning, but the one we are currently on. useRequestUrl returns the url we are transitioning to.
  // This behavior only exists in a production build, in a dev build it behaves like it did before 4.5.0.
  const { pathname: path, hostname: host } = url
  const headers = useRequestHeaders()

  return { environment, host, path, headers }
}
